import { useFormContext } from "react-hook-form";
import { type FormField } from "../formFieldType";
import MyBox from "../../MyBox";
import { useAuth } from "@/context/AuthContext";

interface DisplayFieldProps {
  field: FormField;
  formData?: Record<string, any>;
}

export function DisplayFieldSimple({ field, formData }: DisplayFieldProps) {
  const { getValues } = useFormContext();
  const { user } = useAuth(); // ✅ SAFE here

  // Priority: custom render → value → formData → RHF
  const value =
    field.renderCustom
      ? field.renderCustom({ ...getValues(), ...formData, user })
      : field.value ??
        formData?.[field.name] ??
        getValues(field.name);

  const hasValue =
    value !== undefined && value !== null && value !== "";

  return (
    <MyBox topInfo={field?.topInfo}>
      <div className="w-full h-full rounded-lg text-sm  text-gray-900 dark:text-gray-100">
        
        {/* If JSX (custom render), render directly */}
        {typeof value === "object" && value !== null && !Array.isArray(value) ? (
          value
        ) : (
          hasValue ? String(value) : field.emptyText || "-"
        )}

      </div>
    </MyBox>
  );
}
export function DisplayFieldSimple1({ field, formData }: DisplayFieldProps) {
  const { getValues } = useFormContext();
  const { user } = useAuth(); // ✅ SAFE here

  // Priority: custom render → value → formData → RHF
  const value =
    field.renderCustom
      ? field.renderCustom({ ...getValues(), ...formData, user })
      : field.value ??
        formData?.[field.name] ??
        getValues(field.name);

  const hasValue =
    value !== undefined && value !== null && value !== "";

  return (
    <MyBox topText={field.label} required={field.required}>
      <div className="w-full rounded-lg border px-3 py-2 text-sm border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-gray-100">
        
        {/* If JSX (custom render), render directly */}
        {typeof value === "object" && value !== null && !Array.isArray(value) ? (
          value
        ) : (
          hasValue ? String(value) : field.emptyText || "-"
        )}

      </div>
    </MyBox>
  );
}